<template>
  <div class="root-cause-analyses">
    <div class="df vertical desc-space">
      <div class="step-label">{{ props.title }}</div>

      <a-button
        type="dashed"
        style="width: 100px"
        @click="addAnalyse"
        class="space"
        :disabled="props.disabled"
      >
        <PlusOutlined />
        增加
      </a-button>
    </div>
    <template v-for="(item, index) in rootCauseAnalysesList" :key="index">
      <div class="df vertical" :class="[isMobile ? '' : 'describe']">
        <div>
          <div class="df desc-space">
            <div class="subtitle">why{{ index + 1 }}</div>
            <a-textarea
              v-model:value="item.processRecords"
              :style="{ width: isMobile ? '5rem' : '800px' }"
              :disabled="props.disabled"
              auto-size
            ></a-textarea>
          </div>

          <div class="df desc-space">
            <div class="subtitle">图片</div>
            <upload-img-vue
              class="space"
              ref="imgRefList"
              :attachment="item.picture"
              :disabled="props.disabled"
            ></upload-img-vue>
          </div>

          <div class="df desc-space">
            <div class="subtitle">视频</div>
            <upload-video-vue
              class="space"
              ref="videoRefList"
              :attachment="item.video"
              :disabled="props.disabled"
            ></upload-video-vue>
          </div>
        </div>

        <div>
          <MinusCircleOutlined
            v-if="rootCauseAnalysesList.length > 1 && !props.disabled"
            class="dynamic-delete-button"
            :disabled="rootCauseAnalysesList.length === 1"
            @click="removerootCauseAnalysesList(index)"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed, reactive, ref, watch } from "vue";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";
import {
  Toast,
  uploadMedia,
  showUploading,
  hideUploading,
} from "@/utils/index";
import { saveOrUpdateContentDesc } from "@/request/view/repair";
import uploadImgVue from "./uploadImg.vue";
import uploadVideoVue from "./uploadVideo.vue";

export default defineComponent({
  components: {
    PlusOutlined,
    uploadImgVue,
    uploadVideoVue,
    MinusCircleOutlined,
  },
  props: {
    formdata: Object,
    disabled: Boolean,
    rootCauseAnalyses: Array,
    title: String,
    type: String,
  },
  setup(props, context) {
    const store = useStore();
    const isMobile = computed(() => store.state.isMonile);
    const rootCauseAnalysesList = reactive([]);

    const imgRefList = ref();

    const videoRefList = ref();

    const uploadFile = () => {
      return new Promise((resolve, reject) => {
        let promiseArr = [];
        for (let i = 0; i < imgRefList.value.length; i += 1) {
          const imgRef = imgRefList.value[i];
          const videoRef = videoRefList.value[i];
          let p = uploadMedia(imgRef, videoRef);
          promiseArr.push(p);
        }

        Promise.all(promiseArr)
          .then((res) => {
            for (let index = 0; index < res.length; index += 1) {
              const element = res[index];
              rootCauseAnalysesList[index].picture = JSON.stringify(element[0]);
              rootCauseAnalysesList[index].video = JSON.stringify(element[1]);
            }
            resolve(rootCauseAnalysesList);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const uploadContent = async () => {
      showUploading("上传中");
      return new Promise(async (resolve, reject) => {
        uploadFile()
          .then((data) => {
            saveOrUpdateContentDesc(data)
              .then((res) => {
                resolve();
                hideUploading();
              })
              .catch((err) => {
                reject(err);
                hideUploading();
              });
          })
          .catch((err) => {
            reject(err);
            hideUploading();
          });
      });
    };

    const addAnalyse = () => {
      if (rootCauseAnalysesList.length === 5) {
        return Toast("warning", "5Y分析数量不能超过5个", 3);
      }
      rootCauseAnalysesList.push({
        id: null,
        fid: props.formdata.id,
        type: props.type,
        picture: null,
        processRecords: null,
        video: null,
        repairEquipmentId: props.formdata.repairEquipmentId,
      });
    };

    const removerootCauseAnalysesList = (index) => {
      rootCauseAnalysesList.splice(index, 1);
    };

    watch(
      () => props.rootCauseAnalyses,
      (val) => {
        rootCauseAnalysesList.length = 0;
        if (val) {
          rootCauseAnalysesList.push(...val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.formdata,
      (val) => {
        console.log(val);
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      uploadFile,
      addAnalyse,
      imgRefList,
      videoRefList,
      rootCauseAnalysesList,
      removerootCauseAnalysesList,
      uploadContent,
      isMobile,
    };
  },
});
</script>

<style lang="less" scoped>
.root-cause-analyses {
  margin-bottom: 20px;
  .subtitle {
    font-size: 16px;
    width: 90px;
    text-align: right;
    margin: 10px 16px 10px 0;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  .describe {
    margin-left: 120px;
    background: #f9f9f9;
    border-radius: 6px;
    padding: 24px;
  }
  .desc-space {
    margin-bottom: 16px;
  }
  .dynamic-delete-button {
    margin-left: 20px;
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
